import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import OfertaCard from './OfertaCard';
import './UpcomingEvents.css';

const API = '/api';

export default function UpcomingEvents() {
  const { data, isLoading } = useQuery({
    queryKey: ['ofertasDestacadas'],
    queryFn: async () => {
      const res = await fetch(`${API}/ofertas/destacadas`).then(r => r.json());
      return res.exito ? res.datos : [];
    },
    staleTime: 60 * 1000,
  });

  const ofertas = data || [];

  return (
    <section className="proximos" style={{ maxWidth: 1280, margin: '0 auto', padding: '48px 20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontSize: '1.6rem', fontWeight: 800, color: 'var(--color-text-dark)' }}>Ofertas destacadas</h2>
        <Link to="/ofertas" style={{ color: '#679509', fontWeight: 700, textDecoration: 'none' }}>Ver todas</Link>
      </div>

      {isLoading ? (
        <p style={{ color: '#64748b' }}>Cargando ofertas...</p>
      ) : ofertas.length === 0 ? (
        <p style={{ color: '#64748b' }}>Pronto tendremos ofertas destacadas.</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 20 }}>
          {ofertas.map((o) => (
            <OfertaCard
              key={o.id}
              id={o.id}
              slug={o.slug}
              image={o.imagen_principal}
              category={o.categoria?.nombre}
              comercio={o.comercio?.nombre_comercial}
              ciudad={o.ciudad?.nombre}
              titulo={o.titulo}
              precioOriginal={o.precio_original}
              precioPromocional={o.precio_promocional}
              porcentajeDescuento={o.porcentaje_descuento}
              tipo={o.tipo}
              urlAfiliado={o.url_afiliado}
            />
          ))}
        </div>
      )}
    </section>
  );
}
